import FooterAbsolute from '../components/FooterAbsolute';
import Typewriter from 'typewriter-effect';

function Home() {

  return (
    <div>
          <div className="Home">
          <h1>Motion Designer</h1>   
          <div className='TypeWriter'>
          <Typewriter
          options={{
            strings: ['Motion Designer', 'Graphisme Animé', 'Créatif & Passionné', 'Développement Web', 'Disponible pour vos projets'],
            autoStart: true,
            loop: true,
            delay: 35,
          }}
          />
          
          </div>
          
          </div>
          <FooterAbsolute/>        
    </div>
    );
  }

    export default Home;